import React from 'react';
import { Award, GraduationCap } from 'lucide-react';
import { certifications } from '../mockData';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

const About = () => {
  return (
    <section id="about" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#8B9E8A] mb-4">
            À Propos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Professionnelle certifiée au service du bien-être de vos animaux
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            {/* About Text */}
            <div>
              <h3 className="text-3xl font-bold text-[#8B9E8A] mb-6">
                Qui suis-je ?
              </h3>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p className="text-lg">
                  <span className="font-bold text-[#C5A572]">Je m'appelle Elisa</span> et je suis la fondatrice de <span className="font-semibold text-[#C5A572]">Gratia Animalis</span>, votre spécialiste en massage animalier pour chevaux et chiens en Nouvelle-Aquitaine.
                </p>
                <p>
                  Passionnée par le bien-être animal, je propose des soins professionnels adaptés aux besoins spécifiques de chaque animal, qu'il soit athlète de haut niveau ou simple compagnon.
                </p>
                <p>
                  Le massage animalier n'est pas qu'un moment de détente : c'est un véritable outil de prévention et d'accompagnement pour maintenir votre animal en pleine forme, préparer son corps à l'effort et optimiser sa récupération.
                </p>
                <p>
                  Je me déplace jusqu'à <span className="font-semibold text-[#C5A572]">100 km autour de Saint-Médard-en-Jalles</span> pour offrir à vos compagnons des soins de qualité dans leur environnement familier.
                </p>
              </div>
            </div>

            {/* Profile Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/3g1onenw_IMG_1693.jpeg"
                  alt="Elisa - Praticienne Gratia Animalis"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#8B9E8A]/60 via-transparent to-transparent"></div>
              </div>
            </div>
          </div>

          {/* Certifications */}
          <div>
            <h3 className="text-3xl font-bold text-center text-[#8B9E8A] mb-8 flex items-center justify-center gap-2">
              <GraduationCap className="text-[#C5A572]" />
              Qualifications & Certifications
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {certifications.map((cert, index) => (
                <Card key={index} className="border-[#C5A572]/30 hover:shadow-xl transition-all duration-300 hover:scale-105 bg-white">
                  <CardHeader>
                    <div className="flex items-start gap-4">
                      {cert.logo && (
                        <div className="flex-shrink-0">
                          <img 
                            src={cert.logo} 
                            alt={`Logo ${cert.name}`} 
                            className="w-16 h-16 object-contain rounded-lg"
                          />
                        </div>
                      )}
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-2">
                          <Award className="text-[#C5A572]" size={24} />
                          <CardTitle className="text-[#8B9E8A] text-xl">{cert.name}</CardTitle>
                        </div>
                        <p className="text-gray-600">{cert.description}</p>
                      </div>
                    </div>
                  </CardHeader>
                </Card>
              ))}
            </div>

            <div className="mt-8 bg-[#C5A572]/10 border border-[#C5A572]/30 rounded-xl p-6 text-center">
              <p className="text-gray-700 text-lg">
                Ces formations reconnues garantissent des <span className="font-semibold text-[#8B9E8A]">soins professionnels</span> et <span className="font-semibold text-[#8B9E8A]">adaptés</span> aux besoins spécifiques de vos animaux.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
